/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTag } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTag';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTagFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTagFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTagToJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTagToJSONTyped,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTag';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserToJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserToJSONTyped,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadToJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadToJSONTyped,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead';

/**
 * 
 * @export
 * @interface FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner
 */
export interface FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    facility_id?: string;
    /**
     * 
     */
    lead_id?: string;
    /**
     * 
     */
    tag_id?: string;
    /**
     * 
     */
    comment?: string;
    /**
     * 
     */
    created_by_user_id?: string;
    /**
     * 
     */
    screener_tag?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTag;
    /**
     * 
     */
    user?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser;
    /**
     * 
     */
    lead?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead;
    /**
     * 
     */
    created_at?: string;
}

/**
 * Check if a given object implements the FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner interface.
 */
export function instanceOfFindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner(value: object): value is FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner {
    return true;
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerFromJSON(json: any): FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner {
    return FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerFromJSONTyped(json, false);
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'facility_id': json['facility_id'] == null ? undefined : json['facility_id'],
        'lead_id': json['lead_id'] == null ? undefined : json['lead_id'],
        'tag_id': json['tag_id'] == null ? undefined : json['tag_id'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'created_by_user_id': json['created_by_user_id'] == null ? undefined : json['created_by_user_id'],
        'screener_tag': json['screener_tag'] == null ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTagFromJSON(json['screener_tag']),
        'user': json['user'] == null ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSON(json['user']),
        'lead': json['lead'] == null ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSON(json['lead']),
        'created_at': json['created_at'] == null ? undefined : json['created_at'],
    };
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerToJSON(json: any): FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner {
    return FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerToJSONTyped(json, false);
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerToJSONTyped(value?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'facility_id': value['facility_id'],
        'lead_id': value['lead_id'],
        'tag_id': value['tag_id'],
        'comment': value['comment'],
        'created_by_user_id': value['created_by_user_id'],
        'screener_tag': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTagToJSON(value['screener_tag']),
        'user': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserToJSON(value['user']),
        'lead': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadToJSON(value['lead']),
        'created_at': value['created_at'],
    };
}

